import { Box, Typography, CircularProgress } from '@mui/material';

const SplashScreen = () => (
  <Box
    sx={{
      position: 'fixed',
      inset: 0,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 3,
      backgroundColor: '#F9F7F4',
      zIndex: 9999,
    }}
  >
    <img src="/couplendarlogo.png" alt="Couplendar" style={{ width: 80, height: 80 }} />
    <Typography
      variant="h4"
      sx={{ fontFamily: '"Cormorant Garamond", Georgia, serif', color: '#2A2535', letterSpacing: '0.01em' }}
    >
      Couplendar
    </Typography>
    <CircularProgress size={24} sx={{ color: '#7B6B8D', mt: 1 }} />
  </Box>
);

export default SplashScreen;
